<div data-cy="portfolioDashboard" class="main-content mt-16">
  <div class="pl-3 pr-1.5 lg:pl-[1rem] pb-3 pt-2">
    @if (errorMessage || showNoAccessError) {
      <div class="ml-3">
        @if (showNoAccessError) {
          <div>
            <app-no-access-error></app-no-access-error>
          </div>
        } @else {
          <div class="row mr-0">
            <div class="col-12">
              <div class="mt-3 dashboard-error">
                <div>
                  <h3 class="text-center">{{errorMessage}}</h3>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
    @if (!errorMessage && !showNoAccessError) {
      <div class="container">
        <div class="heading-row">
          <div class="grid grid-cols-2 heading">
            <h1 class="heading__title text-5xl md:text-6xl">Dashboard</h1>
            <div class="text-right asOfDate flex flex-row ml-auto">
              <span class="asOfDate__text self-center pr-2 mb-0.5">as of</span>
              <gcm-date-picker [dateOptionList]="asOfDropdownData" [date]="selectedAsOfDate" (dateChange)="updateAsOfDate($event)"
              [selectPanelClass]="'as-of-date-panel'" data-cy="asOfDateDropdown" tourAnchor="investor.dashboard.reportingPeriod" class="as-of-date"></gcm-date-picker>
            </div>
          </div>
        </div>
        @if (data) {
          <app-portfolio-summary [portfolioSummary]="data.summary" [iconSet]="iconSet()" [selectedAsOfDate]="reportingPeriod" [showFirstSeries]="true" [investorId]="$any(investorId())"></app-portfolio-summary>
        }
      </div>
    }
  </div>
</div>